import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

// ユーザーIDからアカウントIDを取得
export const getAccountId = async (userId) => {
    try {
        const userDoc = await getDoc(doc(db, 'users', userId));

        if (userDoc.exists()) {
            const userData = userDoc.data();
            return userData.accountId || userId; // アカウントIDが設定されていない場合はユーザーIDを返す
        }

        // ユーザードキュメントが存在しない場合は、デフォルトでユーザーIDをアカウントIDとして設定
        await setDoc(doc(db, 'users', userId), {
            userId: userId,
            accountId: userId,
            createdAt: new Date(),
            updatedAt: new Date()
        });

        return userId;
    } catch (error) {
        console.error('アカウントID取得エラー:', error);
        // エラーの場合はユーザーIDを返す
        return userId;
    }
};

// アカウントIDを設定
export const setAccountId = async (userId, accountId) => {
    try {
        await setDoc(doc(db, 'users', userId), {
            userId: userId,
            accountId: accountId,
            updatedAt: new Date()
        }, { merge: true });

        return true;
    } catch (error) {
        console.error('アカウントID設定エラー:', error);
        throw error;
    }
};

// アカウント情報を取得
export const getAccountInfo = async (userId) => {
    try {
        const userDoc = await getDoc(doc(db, 'users', userId));

        if (userDoc.exists()) {
            return userDoc.data();
        }

        return null;
    } catch (error) {
        console.error('アカウント情報取得エラー:', error);
        throw error;
    }
}; 